import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import { ToastContainer } from 'react-toastify';
import { store } from './redux/store';
import '../node_modules/font-awesome/css/font-awesome.css';
import '../node_modules/react-toastify/dist/ReactToastify.css';
import './assets/css/style.css';
import './assets/css/rc-tab.override.css';
import 'rc-tabs/assets/index.css';
import '../node_modules/swiper/swiper.min.css';
import '../node_modules/swiper/modules/navigation/navigation.min.css';
import '../node_modules/swiper/modules/pagination/pagination.min.css';
import App from './App';
import StagingGate from './components/StagingGate';

if (process.env.NODE_ENV === 'development') {
  require('./assets/tailwind/input.css');
} else if (process.env.NODE_ENV === 'production') {
  require('./assets/tailwind/input.css');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

export const history = createBrowserHistory();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <StagingGate>
        <App />
        <ToastContainer theme="colored" autoClose={2000} />
      </StagingGate>
    </Provider>
  </React.StrictMode>
);
